import React from "react";
import { CellProps, Column } from "react-table";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { Rule } from "interfaces/rule";

export interface RuleTableColumnProps {
  onClickEdit: (event: React.MouseEvent, rule: Rule) => void;
}
export const RULE_TABLE_COLUMNS = ({
  onClickEdit
}: RuleTableColumnProps): Column<Rule>[] => [
  {
    Header: "Name",
    id: "rule_name",
    accessor: data => data.rule_name,
    disableSortBy: true
  },
  {
    Header: "Tag",
    id: "tag_name",
    accessor: data => data.tag_name,
    disableSortBy: true
  },
  {
    Header: "Active",
    id: "rule_enabled",
    accessor: data => {
      if (data.rule_enabled) {
        return "true";
      }
      return "false";
    },
    disableSortBy: true
  },
  {
    Header: "Action",
    id: "active_alerts",
    Cell: (cellProps: CellProps<Rule>) => (
      <IconButton
        title={`Edit ${cellProps.row.original.rule_name}`}
        onClick={event => {
          event.stopPropagation();
          onClickEdit(event, cellProps.row.original);
        }}
        color="primary"
        size="large"
      >
        <EditIcon />
      </IconButton>
    ),
    disableSortBy: true
  }
];
